
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Information","d":"M57 49a8 8 0 108 8 8 8 0 00-8-8zm-.16 3.046a1.255 1.255 0 11-1.254 1.254 1.255 1.255 0 011.254-1.254zm1.888 9.908h-3.457v-1.677h.629v-2.854h-.62v-1.678h2.815v4.531h.634z","transform":"translate(-49 -49)","fill":"#196cae","opacity":".501"}})])
          )
        }
      }
    